<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  margin: 20px 100px 50px 100px;
}
</style>



// WEBPACK FOOTER //
// App.vue?ae3c6930